(function() {
    'use strict';
    angular
        .module('publicGatewayApp')
        .factory('GeonameLocalization', GeonameLocalization);

    GeonameLocalization.$inject = ['$resource'];

    function GeonameLocalization ($resource) {
        var resourceUrl =  'api/geoname-localizations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
